import {observer} from 'mobx-react-lite'
import React, {useRef} from 'react'
import {Lang} from 'yougile-lang'
import {
  getSafeObjFromLocalStorage,
  saveSafeObjToLocalStorage
} from '@client/storage'
import {Tracking, TrackingEvent} from '@common/tracking'
import {useBoardStore} from '@components/board/board-store'
import {Dialog} from '@components/common/base/dialog/dialog'
import {useInputKeyDown} from '@containers/hooks'
import {createMirroredTaskById} from '@extensions/mirrored-tasks/create-mirrored-task'

export const CreateMirroredTaskPopup = observer(() => {
  const [state] = useBoardStore()

  if (!state.showPopupCreateMirroredTask) {
    return null
  }

  return <CreateMirroredTaskPopupBase />
})

const CreateMirroredTaskPopupBase = observer(() => {
  const [state, store] = useBoardStore()

  const close = () => {
    store.setShowPopupCreateMirroredTask(undefined)
  }

  const onSubmit = () => {
    if (state.showPopupCreateMirroredTask) {
      Tracking.send(TrackingEvent.reportColumnCreateMirroredTaskViaReportColumn)
      void createMirroredTaskById(state.showPopupCreateMirroredTask)
    }

    close()
  }

  const inputRef = useRef<HTMLInputElement>()
  useInputKeyDown({
    ref: inputRef,
    save: () => {
      onSubmit()
      return true
    },
    cancel: () => {
      close()
      return true
    }
  })

  return (
    <Dialog
      close={close}
      submit={onSubmit}
      title={Lang.msg.statsReportsTable.attentionCreateMirrorTitle}
      width={360}
      primaryBtnText={Lang.msg.apply}
      noShowMore
      noShowMoreTextCb={noShowMoreTextCb}
    >
      <div className="text-primary body-long-regular cursor-default">
        {Lang.msg.statsReportsTable.attentionCreateMirror}
      </div>
    </Dialog>
  )
})

const noShowMoreTextCb = (value: boolean) => {
  const settings = getSafeObjFromLocalStorage('dialog-no-show-more')
  settings['reports-drag'] = value
  saveSafeObjToLocalStorage('dialog-no-show-more', settings)
}
